/* syk-pdp — productpagina-sectie runtime. Config/data uit window.SP_* (zie de sectie). Vanilla, defensief. */
(function () {
  if (!document.querySelector('.syk-pdp') || window.__sykPdpInit) return;
  window.__sykPdpInit = true;
  var CFG = window.SP_CFG || {};
  var VARS = window.SP_VARS || [];
  var BULK = "https://econcepts.bemashopping.com/delivery/bulk";
  var STAFFEL_URL = "https://econcepts.bemashopping.com/delivery";
  var byId = {};
  VARS.forEach(function (v) { byId[String(v.id)] = v; });
  var DELIV = null; /* levertijd-map per sku, gevuld na de bulk-call */

  /* paginabreed gescoped op .syk-pdp: werkt voor de losse sectie én voor losse blokken in de thema-sectie */
  function $(s, c) { return c ? c.querySelector(s) : document.querySelector('.syk-pdp ' + s); }
  function $all(s, c) { return [].slice.call(c ? c.querySelectorAll(s) : document.querySelectorAll('.syk-pdp ' + s)); }
  function sod(d) { var x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
  function diffDays(d) { return Math.round((sod(d) - sod(new Date())) / 86400000); }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function dateLong(d) { return d.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' }); }
  function dateShort(d) { return d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); }
  function etaShort(d) { var n = diffDays(d); if (n <= 0) return 'Vandaag'; if (n === 1) return 'Morgen'; return cap(dateShort(d)); }
  function inHuis(d) { var n = diffDays(d); if (n <= 0) return 'Vandaag in huis'; if (n === 1) return 'Morgen in huis'; return cap(dateLong(d)); }
  function fmtEUR(n) { try { return n.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' }); } catch (e) { return '€ ' + n.toFixed(2).replace('.', ','); } }
  function dayName(d) { return cap(d.toLocaleDateString('nl-NL', { weekday: 'long' })); }
  /* eerstvolgende werkdag (sla za/zo over) — levering op die dag = "snel" (groen) */
  function nextBusinessDay() { var d = sod(new Date()); d.setDate(d.getDate() + 1); while (d.getDay() === 0 || d.getDay() === 6) { d.setDate(d.getDate() + 1); } return d; }
  function isFastest(d) { return sod(d).getTime() <= nextBusinessDay().getTime(); }

  /* ---- quantity stepper ---- */
  (function () {
    var wrap = $('.buyrow'); if (!wrap) return;
    var input = $('.qty', wrap);
    var minus = $('[data-step="-1"]', wrap);
    var plus = $('[data-step="1"]', wrap);
    function qty() { var n = input ? parseInt(input.value, 10) : 1; return (n && n > 0) ? n : 1; }
    function set(n) { if (!input) return; input.value = Math.max(1, n); input.dispatchEvent(new Event('change', { bubbles: true })); }
    if (minus) minus.addEventListener('click', function () { set(qty() - 1); });
    if (plus) plus.addEventListener('click', function () { set(qty() + 1); });
    /* aantal gewijzigd -> leverdatum/badge opnieuw bepalen (refreshBadgeForQty is gehoist) */
    if (input) {
      input.addEventListener('change', function () { refreshBadgeForQty(); });
      var __qt; input.addEventListener('input', function () { clearTimeout(__qt); __qt = setTimeout(function () { refreshBadgeForQty(); }, 350); });
    }
  })();
  function currentQty() {
    /* aantal komt primair uit de NATIVE thema-aantalkiezer (#quantity / [name="quantity"]); valt terug op ons eigen veld */
    var q = document.getElementById('quantity') || document.querySelector('.f8pr-amount input[name="quantity"]') || $('.buyrow .qty') || document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (n && n > 0) ? n : 1;
  }
  /* De klant gebruikt de NATIVE thema-aantalkiezer, niet ons veld -> levertijd-badge daarop laten reageren. */
  (function watchThemeQty() {
    var __qtT, __lastQ = 1;
    function ping() { clearTimeout(__qtT); __qtT = setTimeout(function () { refreshBadgeForQty(); }, 200); }
    document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') ping(); });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') ping(); });
    /* vangnet: +/- stepperknoppen van het thema vuren soms geen change/input -> na elke klik het aantal herlezen */
    document.addEventListener('click', function () { setTimeout(function () { var q = currentQty(); if (q !== __lastQ) { __lastQ = q; refreshBadgeForQty(); } }, 80); }, true);
  })();

  /* ---- thema-eigen cart-drawer (aside#cart) verversen + openen na een toevoeging ---- */
  function openThemeCart() {
    try { if (window.ajaxCart) { if (typeof ajaxCart.load === 'function') ajaxCart.load(); if (typeof ajaxCart.fetchCartCount === 'function') ajaxCart.fetchCartCount(); } } catch (e) {}
    ['cart:refresh', 'cart:build'].forEach(function (ev) { try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); } catch (e) {} });
    if (!document.documentElement.classList.contains('m6pn-open')) {
      var opener = document.querySelector('a.m6pn-cli, [data-panel="cart"]');
      if (opener) { try { opener.click(); } catch (e) {} }
    }
  }
  /* prefers-reduced-motion: smooth-scroll uitzetten voor wie dat systeembreed vraagt (audit #23, JS-kant) */
  var SYK_SMOOTH = 'smooth';
  try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) SYK_SMOOTH = 'auto'; } catch (e) {}

  /* ---- ATC-metingen (audit #27): fetch('/cart/add.js') vult GA4/GTM/Klaviyo NIET automatisch -> defensief zelf pushen.
     Bron = de /cart/add.js-RESPONSE (bevat titel/prijs/variant/sku — geen lookups nodig).
     BEWUST NIET: Shopify.analytics.publish('product_added_to_cart') — trekkie instrumenteert cart-AJAX zelf al,
     nogmaals publiceren = dubbeltelling in web pixels. BEWUST NIET: Elevar 'dl_add_to_cart' — dat schema vult
     Elevars eigen listener; een handmatige push met afwijkend formaat verstoort de server-side feed. ---- */
  function sykTrackATC(res) {
    var items = (res && res.items) ? res.items : (res && res.id ? [res] : []);
    if (!items.length) return;
    var gaItems = [], value = 0;
    items.forEach(function (it) {
      var p = (it.price || 0) / 100;
      value += p * (it.quantity || 1);
      gaItems.push({ item_id: String(it.variant_id || it.id || ''), item_name: it.product_title || it.title || '', item_variant: it.variant_title || '', price: p, quantity: it.quantity || 1 });
    });
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); /* GTM-conventie: vorige ecommerce-object wissen */
      window.dataLayer.push({ event: 'add_to_cart', ecommerce: { currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', value: Math.round(value * 100) / 100, items: gaItems } });
    } catch (e) {}
    try {
      var k = window.klaviyo || window._learnq;
      if (k && typeof k.push === 'function') {
        items.forEach(function (it) {
          k.push(['track', 'Added to Cart', { $value: Math.round((it.price || 0) * (it.quantity || 1)) / 100, Name: it.product_title || it.title || '', ProductID: it.product_id || '', VariantID: it.variant_id || it.id || '', SKU: it.sku || '', Quantity: it.quantity || 1, URL: location.href }]);
        });
      }
    } catch (e) {}
  }
  function addToCartAjax(items, done, fail) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (res) { try { sykTrackATC(res); } catch (e) {} if (done) done(); })
      .catch(function () { if (fail) fail(); });
  }

  /* ---- hoofd-koopknop: AJAX toevoegen + cart-drawer openen (i.p.v. paginanavigatie) ---- */
  (function () {
    var form = $('.syk-pdp-form'); if (!form) return;
    form.addEventListener('submit', function (e) {
      var v = selectedVar(); if (!v || !v.id) return;
      e.preventDefault();
      if (!v.available) return;
      var btn = $('.cta', form); if (btn) btn.disabled = true;
      addToCartAjax([{ id: v.id, quantity: currentQty() }],
        function () { if (btn) btn.disabled = false; openThemeCart(); },
        function () { if (btn) btn.disabled = false; if (typeof form.submit === 'function') form.submit(); });
    });
  })();

  /* ---- galerij: thumbnails/bolletjes/swipe wisselen; klik + loep openen de lightbox ---- */
  (function () {
    var gmain = $('.gmain'); if (!gmain) return;
    var mainImg = $('.gimg', gmain) || $('img', gmain); if (!mainImg) return;
    var thumbs = $all('.thumbs .th');
    var dots = $all('.gdots b');
    var cnt = $('.gc-n', gmain);
    var imgs = (window.SP_IMAGES && window.SP_IMAGES.length)
      ? window.SP_IMAGES.map(function (o) { return o.full; })
      : thumbs.map(function (t) { return t.getAttribute('data-full'); });
    imgs = imgs.filter(Boolean);
    var n = imgs.length; if (n < 1) return;
    var cur = 0;
    function show(i) {
      if (i < 0) i = n - 1; else if (i >= n) i = 0;
      cur = i;
      if (imgs[i]) mainImg.src = imgs[i];
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (cnt) cnt.textContent = (i + 1);
      var at = thumbs[i];
      if (at && at.scrollIntoView) { try { at.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });

    /* lightbox = Fancybox (identiek aan het live thema) */
    function openLb() {
      if (window.Fancybox && typeof window.Fancybox.show === 'function') {
        window.Fancybox.show(imgs.map(function (s) { return { src: s, type: 'image' }; }), { startIndex: cur });
      }
    }
    mainImg.addEventListener('click', openLb);
    var gz = $('.gzoom', gmain);
    if (gz) gz.addEventListener('click', function (e) { e.stopPropagation(); openLb(); });

    /* swipe op de hoofdfoto wisselt het beeld */
    var sx = null;
    gmain.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    gmain.addEventListener('touchend', function (e) {
      if (sx == null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 35) show(cur + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });
  })();

  /* ---- maat-selectie: radio's + sticky/koopknop bijwerken ---- */
  function selectedVar() {
    var r = $('input[name="id"]:checked'); if (r && byId[String(r.value)]) return byId[String(r.value)];
    var hid = $('.syk-pdp-form [name="id"]'); if (hid && byId[String(hid.value)]) return byId[String(hid.value)];
    return VARS[0] || null;
  }
  /* uitverkochte (gekozen) variant -> native koopknop verbergen + Klaviyo back-in-stock tonen; anders andersom.
     Vangnet: blijft het Klaviyo-anker leeg (niet geladen), toon dan toch weer de (uitverkocht-)koopknop. */
  function syncBIS(v) {
    var bis = document.getElementById('back-in-stock-block');
    var buys = [].slice.call(document.querySelectorAll('.f8pr-buy-button'));
    var sold = !!(v && v.available === false);
    buys.forEach(function (f) { f.style.display = sold ? 'none' : ''; });
    if (bis) {
      bis.style.display = sold ? '' : 'none';
      if (sold) { setTimeout(function () { if (!bis.querySelector('*')) { buys.forEach(function (f) { f.style.display = ''; }); bis.style.display = 'none'; } }, 2500); }
    }
  }
  function syncSelection() {
    var v = selectedVar(); if (!v) return;
    $all('.sz').forEach(function (b) { b.classList.toggle('sel', String(b.getAttribute('data-id')) === String(v.id)); });
    var stbSize = $('.stb-size b'); if (stbSize && v.title) stbSize.textContent = v.title;
    $all('.cta').forEach(function (c) { c.disabled = !v.available; });
    $all('.sp-buy-id').forEach(function (h) { h.value = v.id; }); /* verborgen id in losse koopknop-blok synchroon houden */
    syncBIS(v); /* koopknop <-> back-in-stock */
    refreshBadgeForQty(); /* levertijd-badge volgt de gekozen maat ÉN het gekozen aantal */
  }
  $all('.sz').forEach(function (b) {
    b.addEventListener('click', function () {
      var id = b.getAttribute('data-id'); if (!id) return;
      if (b.classList.contains('out')) {
        /* uitverkochte maat: wél selecteerbaar -> herlaad met deze variant zodat Klaviyo back-in-stock precies deze variant oppakt en de koopknop wordt vervangen */
        try { var u = new URL(window.location.href); u.searchParams.set('variant', id); window.location.href = u.toString(); }
        catch (e) { window.location.search = '?variant=' + id; }
        return;
      }
      var r = $('input[name="id"][value="' + id + '"]');
      if (r) { r.checked = true; } /* GEEN change-dispatch: dat triggert de thema-handler (custom-async.js) die op onze radio's crasht op undefined data-template (startsWith) */
      syncSelection();
    });
  });
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') syncSelection(); });
  syncSelection();

  /* sticky mobiele koopbalk (audit #2): koopt via de NATIVE koopknop (#AddToCart) zodat alle thema-listeners
     en pixels het bestaande pad volgen; fallback = ons eigen V2-form (ajax, incl. sykTrackATC).
     Zichtbaar zodra de koopknop boven de viewport uit beeld is gescrold; verborgen bij uitverkochte variant. */
  (function () {
    var bar = $('[data-sticky-bar]');
    var stb = $('[data-sticky-add]');
    if (!stb) return;
    var nativeBtn = document.getElementById('AddToCart') || document.querySelector('.f8pr-buy-button [type="submit"], .f8pr-buy-button button[name="add"], button[name="add"]');
    var form = $('.syk-pdp-form');
    if (!nativeBtn && !form) return;
    stb.addEventListener('click', function () {
      var v = selectedVar(); if (v && v.available === false) return;
      if (nativeBtn) { try { nativeBtn.click(); return; } catch (e) {} }
      if (form) { if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit(); }
    });
    if (!bar) return; /* oude markup (sectie-variant zonder data-sticky-bar): alleen de click-hook */
    var lastShow = false;
    function sold() { var v = selectedVar(); return !!(v && v.available === false); }
    function setVis(show) { lastShow = show; if (show && !sold()) bar.removeAttribute('hidden'); else bar.setAttribute('hidden', ''); }
    var watch = nativeBtn || (form ? form.querySelector('.cta') : null);
    if (watch && 'IntersectionObserver' in window) {
      /* alleen tonen als de koopknop BOVEN de viewport verdween (echt voorbij gescrold, niet 'nog onder de vouw') */
      var io = new IntersectionObserver(function (en) { setVis(!en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 });
      io.observe(watch);
    } else { setVis(true); }
    /* maatwissel kan naar uitverkocht schakelen -> zichtbaarheid herzien (radio-change én .sz-klik, die geen change dispatcht) */
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') setVis(lastShow); });
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.sz')) setTimeout(function () { setVis(lastShow); }, 0); });
  })();

  /* ---- LEVERTIJD: 1 bulk-call -> badge naast prijs + per-maat kleurbalk + USP ---- */
  function fmtBadge(d) {
    if (d && !isNaN(d.getTime())) {
      if (isFastest(d)) {
        var n = diffDays(d);
        var word = (n <= 0) ? 'vandaag' : (n === 1 ? 'morgen' : dayName(d));
        var sw = (n <= 0) ? 'Vandaag' : (n === 1 ? 'Morgen' : dayName(d));
        return { later: false, long: (CFG.fast || 'Voor 23:59 besteld =').replace(/\s*$/, ' ') + word + ' in huis', short: sw + ' in huis' };
      }
      return { later: true, long: cap(dateLong(d)), short: cap(dateShort(d)) };
    }
    return { later: false, long: (CFG.fast || 'Voor 23:59 besteld =').replace(/\s*$/, ' ') + 'morgen in huis', short: 'Morgen in huis' };
  }
  function paintSold() {
    var deliv = $('.deliv'); if (!deliv) return;
    deliv.classList.remove('is-later'); deliv.classList.add('is-sold');
    var long = $('.delivery-long', deliv), short = $('.delivery-short', deliv);
    if (long) long.textContent = 'Uitverkocht';
    if (short) short.textContent = 'Uitverkocht';
  }
  function paintBadge(d) {
    var b = fmtBadge(d);
    var deliv = $('.deliv'); if (!deliv) return;
    deliv.classList.remove('is-sold');
    deliv.classList.toggle('is-later', b.later);
    var long = $('.delivery-long', deliv), short = $('.delivery-short', deliv);
    if (long) long.textContent = b.later ? (CFG.later || 'Geleverd op').replace(/\s*$/, ' ') + b.long : b.long;
    if (short) short.textContent = b.short;
  }
  function paintSelectedBadge() {
    var v = selectedVar();
    if (!v || v.available === false) { paintSold(); return; } /* uitverkocht -> 'Uitverkocht' i.p.v. levertijd */
    if (!DELIV) return;
    var rec = DELIV[v.sku];
    paintBadge(rec && rec.deliveryDate ? new Date(rec.deliveryDate) : null);
  }
  /* leverdatum/voorraad-badge mee laten lopen met het gekozen AANTAL via de STAFFEL-endpoint:
     1 call per maat (gecachet), daarna client-side de juiste voorraad-tier kiezen -> instant.
     Verandert pas zichtbaar als het aantal een tier-grens overschrijdt (bv. >178 stuks). */
  var STAFFEL = {};
  var __qtySeq = 0;
  function tierDate(tiers, qty) {
    if (!tiers || !tiers.length) return undefined;        /* onbekend -> badge ongemoeid laten */
    for (var i = 0; i < tiers.length; i++) {
      if (qty <= tiers[i].available) return tiers[i].deliveryDate ? new Date(tiers[i].deliveryDate) : null;
    }
    return null;                                          /* boven de hoogste tier = niet in dit aantal leverbaar */
  }
  function refreshBadgeForQty() {
    var v = selectedVar();
    if (!v || v.available === false) { paintSold(); return; } /* uitverkocht: 'Uitverkocht' (geen levertijd-data nodig) */
    if (!DELIV) return;                                   /* nog geen levertijd-data geladen */
    var q = currentQty();
    if (q <= 1) { paintSelectedBadge(); return; }
    if (STAFFEL[v.sku]) { var dc = tierDate(STAFFEL[v.sku], q); if (dc !== undefined) { paintBadge(dc); } return; }
    var seq = ++__qtySeq;
    fetch(STAFFEL_URL, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: [{ sku: v.sku, quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        STAFFEL[v.sku] = (data && data.length) ? data : [];
        if (seq !== __qtySeq) return;                     /* alleen de laatste keuze telt */
        var d2 = tierDate(STAFFEL[v.sku], q);
        if (d2 !== undefined) paintBadge(d2);
      })
      .catch(function () { /* API onbereikbaar: laat de bestaande badge staan */ });
  }
  function paintBars(products) {
    $all('.sz').forEach(function (sz) {
      var v = byId[String(sz.getAttribute('data-id'))]; if (!v) return;
      var bar = $('.bar', sz);
      var st = 'sold', d = null;
      if (v.available) {
        var rec = products[v.sku]; d = rec && rec.deliveryDate ? new Date(rec.deliveryDate) : null;
        st = (d && !isNaN(d.getTime()) && isFastest(d) == false) ? 'later' : 'fast';
      }
      var col = st === 'fast' ? (CFG.cFast || '#1f9d57') : (st === 'later' ? (CFG.cLater || '#d9650a') : (CFG.cSold || '#9aa3ab'));
      if (bar) bar.style.background = col;
      if (CFG.sizeEtaOn) {
        var eta = $('.sz-eta', sz);
        if (!eta) { eta = document.createElement('span'); eta.className = 'sz-eta'; sz.appendChild(eta); }
        eta.textContent = (st === 'sold') ? 'Uitverkocht' : ((d && !isNaN(d.getTime())) ? etaShort(d) : '');
      }
    });
  }
  function pickFastest(products) {
    var best = null, bestDate = null;
    VARS.forEach(function (v) {
      if (!v.available) return;
      var rec = products[v.sku]; if (!rec || !rec.deliveryDate) return;
      var d = new Date(rec.deliveryDate); if (isNaN(d.getTime())) return;
      if (!bestDate || d < bestDate) { bestDate = d; best = v; }
    });
    return { v: best, d: bestDate };
  }
  if (VARS.length) {
    fetch(BULK, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: VARS.map(function (v) { return { sku: v.sku, quantity: 1, available: v.available }; }) }) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) ? data.products : {};
        DELIV = products;
        paintBars(products);
        var sel = selectedVar();
        var fast = pickFastest(products);
        /* auto-select snelste leverbare maat (1x) als er nog niets gekozen is */
        if (CFG.autoOn && fast.v && (!sel || !sel.available)) {
          var r = $('input[name="id"][value="' + fast.v.id + '"]');
          if (r && !r.checked) { r.checked = true; } /* idem: geen change-dispatch naar de crashende thema-handler */
          syncSelection();
        }
        /* badge volgt de gekozen maat; valt anders terug op de snelste leverbare */
        var cur = selectedVar();
        if (cur && cur.available && products[cur.sku] && products[cur.sku].deliveryDate) {
          paintSelectedBadge();
        } else if (fast.v && products[fast.v.sku] && products[fast.v.sku].deliveryDate) {
          paintBadge(new Date(products[fast.v.sku].deliveryDate));
        } else if (cur && cur.available === false) {
          paintSold();
        } else {
          paintBadge(null);
        }
      })
      .catch(function () { /* TODO levertijd-API onbereikbaar: server-gerenderde badge blijft staan */ });
  }

  /* ---- tabs (.syk-pdp.info-blocks is al server-side gezet -> dan geen tab-wissel nodig) ---- */
  (function () {
    /* tabs altijd actief (info-blocks-modus vervallen) */
    var panels = $all('.tabpanel'), btns = $all('.tabbtn');
    function showTab(id) {
      if (!$('#' + id)) return;
      panels.forEach(function (p) { p.classList.toggle('on', p.id === id); });
      btns.forEach(function (t) {
        var on = t.getAttribute('data-tab') === id;
        t.classList.toggle('on', on);
        /* ARIA-tabs (audit #8): alleen syncen als de Liquid de role al zet — progressive enhancement */
        if (t.getAttribute('role') === 'tab') t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      /* lazy-load-widgets (bv. Judge.me) in het nu-zichtbare paneel laten initialiseren */
      try { window.dispatchEvent(new Event('resize')); window.dispatchEvent(new Event('scroll')); } catch (e) {}
    }
    btns.forEach(function (t) { t.addEventListener('click', function () { showTab(t.getAttribute('data-tab')); }); });
    $all('[data-tab-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('data-tab-link'); var el = $('#' + id);
        if (el) { e.preventDefault(); showTab(id); try { el.scrollIntoView({ behavior: SYK_SMOOTH, block: 'start' }); } catch (x) {} }
      });
    });
    /* thema-ankerlinks naar de juiste tab: sterren (#judgeme_product_reviews) -> Beoordelingen,
       'lees meer' (#section-info) -> eerste tab (Beschrijving). De thema-id's bestaan niet in onze tabs.
       Zoek de tab-knop GLOBAAL (niet via .sp-sec — die class is niet uniek, vandaar dat 'ie eerder op Beschrijving bleef). */
    function syk_jumpHash(hash) {
      var btn = null;
      if (hash === '#judgeme_product_reviews') { btn = $('.tabbtn[data-tab="sp-reviews"]'); }
      else if (hash === '#section-info') { btn = $('.tabnav .tabbtn'); }
      else { return false; }
      if (!btn) return false;
      var id = btn.getAttribute('data-tab');
      showTab(id);
      var panel = $('#' + id);
      var wrap = (panel && panel.closest('.sp-sec')) || btn.closest('.sp-sec') || panel || btn;
      if (wrap) { try { wrap.scrollIntoView({ behavior: SYK_SMOOTH, block: 'start' }); } catch (x) {} }
      return true;
    }
    document.addEventListener('click', function (e) {
      var a = (e.target && e.target.closest) ? e.target.closest('a[href="#section-info"],a[href="#judgeme_product_reviews"]') : null;
      if (a && syk_jumpHash(a.getAttribute('href'))) e.preventDefault();
    });
    if (location.hash === '#section-info' || location.hash === '#judgeme_product_reviews') {
      setTimeout(function () { syk_jumpHash(location.hash); }, 350);
    }
  })();

  /* ---- "Maak je look compleet": aantal-stepper vóór de complete-look-knop; los item toevoegen; herhaald toevoegen (andere maat) mogelijk ---- */
  $all('.look').forEach(function (lookRoot) {
    var box = lookRoot.querySelector('.items'); if (!box) return;
    var items = $all('.item', box);
    var totalEl = lookRoot.querySelector('[id^="sp-looktotal"]'), oldEl = lookRoot.querySelector('[id^="sp-lookold"]');
    var dattr = (lookRoot.getAttribute('data-disc') || '').replace(/[^0-9.]/g, '');
    var disc = dattr ? parseFloat(dattr) : parseFloat(CFG.lookDiscount);
    if (isNaN(disc) || disc < 0 || disc >= 100) disc = 0;
    /* native .input-amount-stepper VERVANGT het <input> bij init (innerHTML-rewrap) -> NIET cachen, elke keer vers uitlezen */
    function lookQty() { var qi = lookRoot.querySelector('.look-amount input'); var n = qi ? parseInt(qi.value, 10) : 1; return (n && n > 0) ? n : 1; }
    function recalc() {
      var sum = 0;
      items.forEach(function (it) { if (!it.hidden) sum += parseFloat(it.getAttribute('data-price') || 0); });
      var n = lookQty();
      var net = Math.round(sum * (1 - disc / 100) * n * 100) / 100;
      if (totalEl) totalEl.textContent = fmtEUR(net);
      if (oldEl) oldEl.textContent = disc > 0 ? 'i.p.v. ' + fmtEUR(sum * n) : '';
    }
    recalc();
    function addToCart(payload, done, fail) {
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/add.js', true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () { if (x.status >= 200 && x.status < 300) { try { sykTrackATC(JSON.parse(x.responseText)); } catch (e) {} if (done) done(); } else if (fail) fail(); };
      x.onerror = function () { if (fail) fail(); };
      x.send(JSON.stringify(payload));
    }
    function refreshCart() {
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true })); } catch (e) {}
    }
    /* los item: korte ✓-bevestiging, daarna weer toevoegbaar (geen permanente vergrendeling) */
    function flashBtn(btn, html) {
      btn.disabled = true; btn.classList.add('inset'); btn.innerHTML = '<i class="ti ti-check"></i>';
      setTimeout(function () { btn.disabled = false; btn.classList.remove('inset'); btn.innerHTML = html; }, 1600);
    }
    box.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.iadd') : null;
      if (!btn || btn.disabled) return;
      var it = btn.closest('.item'); if (!it) return;
      var vid = btn.getAttribute('data-vid');
      var sel = $('.ivar', it);
      if (sel && !btn.getAttribute('data-vid')) {
        if (!sel.value) { try { sel.focus(); } catch (x) {} return; }
        vid = sel.value;
      } else if (sel && sel.value) { vid = sel.value; }
      if (!vid) return;
      var orig = btn.innerHTML;
      btn.disabled = true;
      addToCart({ items: [{ id: vid, quantity: 1 }] }, function () { flashBtn(btn, orig); refreshCart(); }, function () { btn.disabled = false; });
    });
    /* native thema-stepper (.input-amount) handelt de +/- zelf af én vervangt het <input> bij init;
       daarom gedelegeerd herberekenen (een gecachte referentie zou stale zijn). */
    var amtEl = lookRoot.querySelector('.look-amount');
    if (amtEl) amtEl.addEventListener('click', function () { setTimeout(recalc, 0); });
    lookRoot.addEventListener('input', function (e) { if (e.target && e.target.closest && e.target.closest('.look-amount')) setTimeout(recalc, 0); });
    document.addEventListener('change', function (e) { if (e.target && (e.target.name === 'quantity' || (e.target.closest && e.target.closest('.look-amount')))) recalc(); });
    var lookCta = lookRoot.querySelector('.lookcta');
    if (lookCta) {
      var ctaOrig = lookCta.innerHTML;
      lookCta.addEventListener('click', function () {
        var n = lookQty();
        var payload = [];
        var mv = selectedVar();
        if (mv && mv.available && mv.id) payload.push({ id: String(mv.id), quantity: currentQty() * n });
        items.forEach(function (it) {
          if (it.hidden || it.classList.contains('item-main')) return;
          var sel = $('.ivar', it);
          var ib = $('.iadd', it);
          var vid = (ib && ib.getAttribute('data-vid')) || (sel ? sel.value : '');
          if (vid) payload.push({ id: vid, quantity: n });
        });
        if (!payload.length) return;
        lookCta.disabled = true; lookCta.innerHTML = '<i class="ti ti-check"></i> Toegevoegd — kies evt. een andere maat';
        addToCart({ items: payload }, function () {
          refreshCart(); openThemeCart();
          setTimeout(function () { lookCta.disabled = false; lookCta.innerHTML = ctaOrig; recalc(); }, 2200);
        }, function () { lookCta.disabled = false; lookCta.innerHTML = ctaOrig; });
      });
    }
  });

  /* ---- "Maak je look compleet": levertijd per item (incl. hoofdproduct) + maat-sync hoofdproduct ---- */
  (function lookItemDelivery() {
    var lookItems = $all('.look .item[data-sku]');
    if (!lookItems.length) return;
    function paintItem(it, d) {
      var t = it.querySelector('.idel-txt'); if (!t) return;
      var hasDate = d && !isNaN(d.getTime());
      t.textContent = hasDate ? inHuis(d) : 'Morgen in huis';
      /* latere datum (niet morgen) -> oranje, net als de levertijd-badge bovenaan; anders groen */
      var wrap = it.querySelector('.idel');
      if (wrap) wrap.classList.toggle('is-later', hasDate && isFastest(d) == false);
    }
    var seen = {}, skus = [];
    lookItems.forEach(function (it) { var s = it.getAttribute('data-sku'); if (s && !seen[s]) { seen[s] = 1; skus.push(s); } });
    if (skus.length) {
      fetch(BULK, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: skus.map(function (s) { return { sku: s, quantity: 1, available: true }; }) }) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) ? data.products : {};
          $all('.look .item[data-sku]').forEach(function (it) {
            var rec = products[it.getAttribute('data-sku')];
            paintItem(it, rec && rec.deliveryDate ? new Date(rec.deliveryDate) : null);
          });
        })
        .catch(function () { /* API onbereikbaar: laat "Morgen in huis" staan */ });
    }
    /* hoofdproduct-regel: sku/levertijd + maatkiezer mee laten lopen met de gekozen maat */
    var mainItem = $('.look .item-main'); if (!mainItem) return;
    var ivarMain = mainItem.querySelector('.ivar-main');
    function syncMain() {
      var v = selectedVar(); if (!v) return;
      mainItem.setAttribute('data-sku', v.sku);
      if (ivarMain) { try { ivarMain.value = v.id; } catch (e) {} }
      if (DELIV && DELIV[v.sku]) paintItem(mainItem, DELIV[v.sku].deliveryDate ? new Date(DELIV[v.sku].deliveryDate) : null);
    }
    if (ivarMain) ivarMain.addEventListener('change', function () {
      var r = $('input[name="id"][value="' + ivarMain.value + '"]'); if (r) { r.checked = true; syncSelection(); }
      syncMain();
    });
    $all('.sz').forEach(function (b) { b.addEventListener('click', function () { setTimeout(syncMain, 0); }); });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') syncMain(); });
    syncMain();
  })();

  /* ---- collectieslider-pijlen (per blok-instantie) ---- */
  $all('.cs-track').forEach(function (track) {
    var wrap = track.closest('.cs-wrap'); if (!wrap) return;
    var prev = wrap.querySelector('.cs-prev'), next = wrap.querySelector('.cs-next');
    function step() { var it = track.querySelector('.cs-item'); var w = it ? it.getBoundingClientRect().width : 92; return Math.max(1, Math.round((track.clientWidth - w) / (w + 18))) * (w + 18); }
    function sync() { if (!prev || !next) return; var max = track.scrollWidth - track.clientWidth - 1; prev.disabled = track.scrollLeft <= 0; next.disabled = track.scrollLeft >= max; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: SYK_SMOOTH }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: SYK_SMOOTH }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---- recent bekeken: pijlen + wishlist + localStorage-vulling ---- */
  (function () {
    var tracks = $all('.rv-track'); if (!tracks.length) return;
    tracks.forEach(function (track) {
      var sec = track.closest('.rv-sec') || track.parentNode;
      [].slice.call(sec.querySelectorAll('.rv-arrow')).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = parseInt(b.getAttribute('data-rv-dir'), 10) || 1;
          track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: SYK_SMOOTH });
        });
      });
      track.addEventListener('click', function (e) {
        var w = e.target.closest ? e.target.closest('.rv-wish') : null;
        if (w) { e.preventDefault(); e.stopPropagation(); w.classList.toggle('rv-on'); }
      });
    });

    var handle = CFG.handle || '';
    var firstSec = tracks[0].closest('.rv-sec');
    var max = parseInt((firstSec && firstSec.getAttribute('data-count')) || CFG.recentCount, 10) || 8;
    /* Gebruik de NATIVE theme-historie: localStorage 'recentlyViewedProduct' = [{productUrl, productId}, ...],
       die het thema zelf op ELKE productpagina bijwerkt. Zo loopt 'recent bekeken' exact synchroon met de
       rest van de site (en niet meer een losse, lege eigen lijst). Nieuwste eerst, huidige uitgesloten. */
    function read() {
      var arr = []; try { arr = JSON.parse(localStorage.getItem('recentlyViewedProduct') || '[]') || []; } catch (e) {}
      var out = [];
      for (var i = arr.length - 1; i >= 0; i--) {
        var u = arr[i] && arr[i].productUrl; if (!u) continue;
        /* Alleen echte product-URL's: /products/<handle>. Sla afbeeldings-/andere URL's over -
           een handle met een punt (.jpg/.png) gaf eerder fetch /products/<bestand>.js -> 404. */
        var m = String(u).split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
        var h = m && m[1];
        if (h && h.indexOf('.') === -1 && h !== handle && out.indexOf(h) < 0) out.push(h);
      }
      return out;
    }
    var list = read();

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function card(p) {
      var img = p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<i class="ti ti-photo" aria-hidden="true"></i>';
      var price = (p.price_min != null && p.price_max != null && p.price_min !== p.price_max)
        ? '<small>Vanaf</small> ' + fmtEUR((p.price_min || 0) / 100)
        : fmtEUR((p.price || 0) / 100);
      var sizes = (p.options_sizes || []).slice(0, 6).map(function (o) { return '<span class="rv-pill' + (o.available ? '' : ' rv-out') + '">' + esc(o.name) + '</span>'; }).join('');
      var dtxt = 'Voor 23:59 besteld, morgen in huis', dcls = '', dicon = 'ti-truck';
      if (p.available === false) { dtxt = 'Uitverkocht'; dcls = ' rv-del-sold'; dicon = 'ti-ban'; }
      else if (p.delivery && !isNaN(p.delivery.getTime())) {
        if (isFastest(p.delivery)) {
          var nn = diffDays(p.delivery);
          dtxt = (nn <= 0 ? 'Vandaag' : (nn === 1 ? 'Morgen' : dayName(p.delivery))) + ' in huis';
        } else { dtxt = cap(dateShort(p.delivery)) + ' in huis'; dcls = ' rv-del-later'; }
      }
      return '<a class="rv-card" href="' + esc(p.url) + '">' +
        '<div class="rv-media">' + img + '<button type="button" class="rv-wish" aria-label="Aan verlanglijst toevoegen"><i class="ti ti-heart"></i></button></div>' +
        '<div class="rv-body"><div class="rv-name">' + esc(p.title) + '</div><div class="rv-price">' + price + '</div>' +
        (sizes ? '<div class="rv-sizes">' + sizes + '</div>' : '') +
        '<div class="rv-delivery' + dcls + '"><i class="ti ' + dicon + '"></i><span>' + esc(dtxt) + '</span></div></div></a>';
    }
    if (!list.length) { $all('.rv-empty').forEach(function (em) { em.hidden = false; }); return; }
    var slice = list.slice(0, max);
    Promise.all(slice.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var built = [], items = [];
      prods.forEach(function (p) {
        if (!p) return;
        var sizeOpt = (p.options || []).indexOf('Maat') > -1 ? 'Maat' : ((p.options || [])[0] || '');
        var sizes = [];
        if (sizeOpt && sizeOpt !== 'Title' && (p.variants || []).length > 1) {
          var seen = {};
          (p.variants || []).forEach(function (v) {
            var name = v.options[(p.options || []).indexOf(sizeOpt)];
            if (name && name !== 'Default Title' && !seen[name]) { seen[name] = 1; sizes.push({ name: name, available: v.available }); }
          });
        }
        /* sku van de snelste leverbare variant (barcode of id) voor de levertijd-lookup */
        var vs = p.variants || [], pick = null;
        for (var k = 0; k < vs.length; k++) { if (vs[k].available) { pick = vs[k]; break; } }
        if (!pick) pick = vs[0];
        var sku = pick ? (pick.barcode || String(pick.id)) : '';
        if (sku) items.push({ sku: sku, quantity: 1, available: pick ? !!pick.available : false });
        built.push({ sku: sku, data: {
          url: p.url, title: p.title,
          featured_image: p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300') : '',
          price: p.price, price_min: p.price_min, price_max: p.price_max, options_sizes: sizes, available: p.available
        } });
      });
      function render(dmap) {
        var html = '';
        built.forEach(function (b) {
          var rec = dmap[b.sku];
          b.data.delivery = (rec && rec.deliveryDate) ? new Date(rec.deliveryDate) : null;
          html += card(b.data);
        });
        if (html) { tracks.forEach(function (t) { t.innerHTML = html; }); } else { $all('.rv-empty').forEach(function (em) { em.hidden = false; }); }
      }
      if (items.length) {
        fetch(BULK, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: items }) })
          .then(function (r) { return r.json(); })
          .then(function (data) { render((data && data.products) || {}); })
          .catch(function () { render({}); });
      } else { render({}); }
    }).catch(function () { $all('.rv-empty').forEach(function (em) { em.hidden = false; }); });
  })();

  /* ===== Thema-galerij verrijken: bestseller-badge + "1 / N"-teller + zoomknop (R5/R6) =====
     De thema-galerij (.l4pr) staat BUITEN .syk-pdp; classes hier zijn dus ongescoped. */
  function enhanceThemeGallery(force) {
    var ul = document.querySelector('.l4pr[data-media-size]');
    if (!ul) return;
    var box = (ul.closest && ul.closest('.l4pr-container')) || ul.parentNode;
    if (!box) return;
    /* WACHT tot het thema de slides in .swiper-wrapper heeft gezet; voegen we onze overlay eerder toe,
       dan verpakt het thema 'm mee als extra slide -> een extra (4e) paginatie-bolletje. force=true overslaat dit (galerij zonder Swiper). */
    if (!force && !ul.querySelector('.swiper-wrapper') && ul.querySelector(':scope > li')) return;
    /* al een overlay geplaatst? dan klaar. */
    if (ul.querySelector(':scope > .syk-gov')) return;
    /* anders eerst eerdere/misplaatste floaters opruimen (Swiper kan losse floaters als 'slide' verpakt hebben) */
    [].forEach.call(document.querySelectorAll('.l4pr-container .syk-gov, .l4pr-container .syk-gcount, .l4pr-container .syk-gzoom, .l4pr-container .syk-gbadge'), function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
    /* overlay die EXACT de (vierkante) foto bedekt (top:0, width:100%, aspect-ratio uit --ratio) -> alle floaters
       op de foto-hoeken, los van de dots/paginatie-strook die ónder de foto in .l4pr zit. */
    var ov = document.createElement('li'); /* <li> i.p.v. <div>: geldige directe child van de <ul.l4pr> (a11y 'list'-audit), blijft absoluut gepositioneerd dus zelfde uitlijning */
    ov.className = 'syk-gov';

    /* alleen echte media-slides: geen palette-/sticky-<li>, moet een afbeelding of fancybox-anchor bevatten */
    /* slides: na Swiper-init zitten ze in .swiper-wrapper (geen directe <li> meer) -> descendant-query; clones overslaan */
    var slides = [].slice.call(ul.querySelectorAll('li.has-anchor, .swiper-slide')).filter(function (n) {
      return !(n.classList && (n.classList.contains('sticky') || n.classList.contains('swiper-slide-duplicate'))) && n.querySelector('a[data-fancybox], picture, img');
    });
    var total = parseInt(ul.getAttribute('data-media-size'), 10) || slides.length;

    /* bestseller-badge uit metaveld custom.galerij_badge (via SP_CFG.galleryBadge) — op de hoofdafbeelding */
    var badgeTxt = (CFG.galleryBadge || '').toString().trim();
    if (badgeTxt) {
      var badge = document.createElement('span');
      badge.className = 'syk-gbadge';
      badge.innerHTML = '<i class="ti ti-flame"></i>';
      badge.appendChild(document.createTextNode(badgeTxt));
      ov.appendChild(badge);
    }

    /* .l4pr (Swiper-container) = positioneringscontext; floaters worden DIRECTE kinderen ervan
       (siblings van .swiper-wrapper) -> Swiper laat ze met rust en ze overlappen exact de foto-viewport. */
    try { if (getComputedStyle(ul).position === 'static') ul.style.position = 'relative'; } catch (e) {}

    /* teller + zoomknop (CSS toont ze nu op desktop én mobiel, op de foto) */
    var counter = document.createElement('span');
    counter.className = 'syk-gcount';
    counter.innerHTML = '<i class="ti ti-photo"></i> <b class="syk-gc-n">1</b> / ' + total;
    ov.appendChild(counter);
    var num = counter.querySelector('.syk-gc-n');

    var zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'syk-gzoom';
    zoom.setAttribute('aria-label', 'Vergroot afbeelding');
    zoom.innerHTML = '<i class="ti ti-zoom-in"></i>';
    ov.appendChild(zoom);
    ul.appendChild(ov); /* overlay als directe child van .l4pr (Swiper laat niet-wrapper kinderen met rust) */

    /* overlay-hoogte = exact de fotohoogte (.swiper-wrapper), NIET de hele .l4pr (incl. dots-strook).
       Lost op dat de teller op desktop te ver naar beneden zakte bij niet-vierkante foto's
       (de CSS-fallback aspect-ratio:1 klopt alleen bij vierkante foto's). */
    function sizeGov() {
      var w = ul.querySelector('.swiper-wrapper') || slides[0];
      if (w) { var h = w.getBoundingClientRect().height; if (h > 20) ov.style.height = h + 'px'; }
    }
    sizeGov();
    [150, 500, 1200, 2400].forEach(function (t) { setTimeout(sizeGov, t); });
    window.addEventListener('resize', sizeGov, { passive: true });
    window.addEventListener('load', sizeGov);

    var activeIdx = 0;
    function setActive(i) { if (i >= 0 && i !== activeIdx) { activeIdx = i; num.textContent = (i + 1); } }

    /* actieve index: Swiper-API als het thema Swiper gebruikt (zo is het), anders scroll-detectie als fallback */
    var sw = ul.swiper || (ul.children[0] && ul.children[0].swiper);
    if (sw && typeof sw.on === 'function') {
      setActive(sw.realIndex || 0);
      sw.on('slideChange', function () { setActive(sw.realIndex || 0); });
    } else {
      var raf = 0;
      function computeActive() {
        raf = 0;
        var cR = ul.getBoundingClientRect();
        var cMid = cR.left + cR.width / 2;
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var r = slides[i].getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - cMid);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        setActive(best);
      }
      function onScroll() { if (!raf) raf = requestAnimationFrame(computeActive); }
      ul.addEventListener('scroll', onScroll, { passive: true });
      if (box !== ul) box.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      computeActive();
    }

    /* zoom → open Fancybox direct met de galerij-bronnen (geen navigatie-risico, juiste startindex) */
    zoom.addEventListener('click', function (ev) {
      ev.preventDefault();
      var anchors = slides.map(function (li) { return li.querySelector('a[data-fancybox]'); }).filter(Boolean);
      if (window.Fancybox && anchors.length) {
        var srcs = anchors.map(function (a) {
          var href = a.getAttribute('href') || '';
          var img = /\.(jpe?g|png|webp|gif|avif)(\?|$)/i.test(href);
          return img ? { src: href, type: 'image' } : { src: href };
        });
        var actA = slides[activeIdx] ? slides[activeIdx].querySelector('a[data-fancybox]') : null;
        var start = actA ? anchors.indexOf(actA) : 0;
        window.Fancybox.show(srcs, { startIndex: start < 0 ? 0 : start });
        return;
      }
      var la = slides[activeIdx] || slides[0];
      var a2 = la && la.querySelector('a[data-fancybox]');
      if (a2) { a2.click(); }
    });
  }
  enhanceThemeGallery();
  setTimeout(function () { enhanceThemeGallery(); }, 700);   /* na de thema-slider-init opnieuw */
  setTimeout(function () { enhanceThemeGallery(); }, 1800);
  setTimeout(function () { enhanceThemeGallery(true); }, 2800); /* fallback: galerij zonder Swiper */
  /* her-uitvoeren wanneer het thema de galerij opnieuw opbouwt (variant-foto-swap, AJAX-navigatie):
     dan zijn onze floaters weg -> de observer voegt ze opnieuw toe (idempotente guard voorkomt dubbel). */
  try {
    var __sykGalObs = new MutationObserver(function () { clearTimeout(window.__sykGalT); window.__sykGalT = setTimeout(enhanceThemeGallery, 150); });
    __sykGalObs.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
